<template>
  <el-row>
    <el-col :span="24">
      <el-card v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Import Tracks User</p>
          <el-dropdown @command="setTrackStatus">
              <span class="el-dropdown-link pointer">
                Status ({{ trackStatus[status] }}) <i class="el-icon-arrow-down el-icon--right" style="color: black !important"></i>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">All</el-dropdown-item>
              <el-dropdown-item command="1">Promotion</el-dropdown-item>
              <el-dropdown-item command="3">Pending</el-dropdown-item>
              <el-dropdown-item command="2">Submitted</el-dropdown-item>
              <el-dropdown-item command="4">Delivered</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div>
            <el-button class="btn-main" @click="handleAnalyzeTracks">
              Analyse Tracks
            </el-button>
            <el-button class="btn-main" @click="handleDownloadTracks">
              Download Tracks
            </el-button>
            <el-button type="success" class="btn-approve" @click="performBatchAction({ status: 'approve' })" v-show="status === '2' || status === '4'">
              Approve
            </el-button>
            <el-button type="success" class="btn-reject" @click="performBatchAction({ status: 'reject' })" v-show="status === '2' || status === '4'">
              Reject
            </el-button>
            <el-button type="success" class="btn-ingest" @click="performBatchAction({ status: 'ingest' })" v-show="status === '2' || status === '4'">
              Delivered
            </el-button>
            <el-button
                type="success"
                class="btn-main"
                @click="generateAll"
            >
              Generate
            </el-button>
            <el-button type="success" class="btn-main" @click="publishAll">
              Publish
            </el-button>
            <el-tooltip content="Upload track" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-upload2"
                @click="setDialogUpload(true)"
              ></el-button>
            </el-tooltip>
            <DialogTrack page="user"/>
          </div>
        </div>
        <div class="import-table-wrap">
<!--        <div>-->
        <el-table :key="status" :data="data.data" class="w100 import-user" :row-class-name="tableRowClassName" height="100vh" @sort-change="handleSort">
          <el-table-column width="100">
            <template #header>
              <el-checkbox
                v-model="selectAll"
                @change="toggleSelectAll"
                class="checkbox-track"
              ></el-checkbox>
              <span>{{ selectedTracks.length }}/{{ data.total || 0 }}</span>
            </template>
            <template #default="props">
              <el-checkbox
                :label="props.row.id"
                :value="props.row.id"
                v-model="selectedTracks"
                class="checkbox-track"
              >
              </el-checkbox>
        </template>
          </el-table-column>
          <el-table-column label="Cover" prop="user_id" width="150">
            <template slot-scope="props">
              <el-popover placement="right" width="220" trigger="hover"
                          :disabled="props.row.admin_errors.length < 1 && +props.row.isrc !== 1">
                <el-badge :value="props.row.admin_errors.length > 0 ? 'error' : 'isrc'" class="item" slot="reference"
                          :hidden="props.row.admin_errors.length < 1 && +props.row.isrc !== 1"
                          :type="+props.row.isrc === 1 ? 'success' : ''">
                  <img v-if="props.row.image_url" class="avatar" :src="props.row.image_url"/>
                  <img v-else class="avatar" :src="`https://app.syncvault.com/static/apple-touch-icon.png`"/>
                </el-badge>
                <div v-if="props.row.admin_errors.length > 0">
                  <h4 class="m0 p0">Errors</h4>
                  <ul class="mt5 p0">
                    <li v-for="error in props.row.admin_errors" :key="error">{{ error }}</li>
                  </ul>
                </div>
                <div v-if="+props.row.isrc === 1">ISRC code needs to be generated</div>
              </el-popover>
              <i class="el-icon-notebook-2 fa-lg pointer" @click="openMetadata(props.row)"></i>
            </template>
          </el-table-column>
          <el-table-column label="Title" prop="title" sortable="custom" width="300">
            <template slot-scope="props">
              <div @click="handleSort('title')" class="sortable-header">
                {{ props.row.title }}
              </div>
              <div v-if="props.row.files_generated">
                <el-tooltip class="item" content="Show player" placement="top-start">
                <i v-if="showWaveform !== props.row.id" class="el-icon-data-analysis fa-2x pointer" @click="showWaveform = props.row.id"></i>
                </el-tooltip>
                <Waveform v-if="showWaveform === props.row.id" :track="props.row" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Artist"
            prop="artist.name"
            sortable="custom"
            width="100"
            @click="handleSort('artist')"
          ></el-table-column>
          <el-table-column 
            label="Uploaded At"
            prop="created_at"
            width="120"
            sortable="custom"
            @click="handleSort('created_at')"
          >
            <template slot-scope="props">
              {{ props.row.created_at | date }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="shouldShowColumn('submitted_at')"
            label="Submitted at"
            prop="submitted_at"
            sortable="custom" 
            @click="handleSort('submitted_at')" 
            width="120"
          >
            <template slot-scope="props">
              {{ props.row.submitted_at | date }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="shouldShowColumn('approved_at')"
            label="Approved At" prop="approved_at" 
            sortable="custom" 
            @click="handleSort('approved_at')"
            width="120"
          >
            <template slot-scope="props">
              {{ props.row.approved_at | date }}
            </template>
          </el-table-column>
          <el-table-column 
            v-if="shouldShowColumn('ingested_at')"
            label="Delivered at"
            prop="ingested_at" 
            sortable="custom" 
            @click="handleSort('ingested_at')"
            width="120"
          >
            <template slot-scope="props">
              {{ props.row.ingested_at | date }}
            </template>
          </el-table-column>
          <el-table-column 
            label="ISRC" 
            prop="isrc" 
            sortable="custom"
            @click="handleSort('isrc')"
          >
            <template slot-scope="props">
              {{ +props.row.isrc === 1 ? '' : props.row.isrc }}
            </template>
          </el-table-column>
          <el-table-column 
            label="Email" 
            prop="email" 
            sortable="custom" 
            @click="handleSort('email')"
            width="200"
          >
            <template slot-scope="props"> {{ props.row.user.email }} </template>
          </el-table-column>
          <el-table-column 
            label="CID Delivery"
            prop="delivered"
            sortable="custom" 
            width="130"
            align="center"
          >
            <template slot-scope="props">
              {{ props.row.delivered ? 'Delivered' : 'Pending' }}
            </template>
          </el-table-column>
          <el-table-column label="CID Territories" prop="cid_territories_option" sortable="custom" width="150">
            <template slot-scope="props">
              <span v-if="props.row.cid_territories_option === 'worldwide'">Worldwide</span>
              <span v-else-if="props.row.cid_territories_option === 'only'" class="pointer" @click="openModal(props.row)">
                <el-tag type="success">Only selected</el-tag>
              </span>
              <span v-else-if="props.row.cid_territories_option === 'except'" class="pointer" @click="openModal(props.row)">
                <el-tag type="warning">All except deselected</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="CID Policy" prop="cid_policy" sortable="custom" width="120">
            <template slot-scope="props">
              <span v-if="props.row.cid_policy === 'monetize'">Monetize All</span>
              <span v-else-if="props.row.cid_policy === 'block'">Block All</span>
              <span v-else-if="props.row.cid_policy === 'review'">Route to Review</span>
              <span v-else-if="props.row.cid_policy === 'track'">Track policy</span>
              <span v-else-if="props.row.cid_policy === 'customize'">Customize</span>
            </template>
          </el-table-column>
          <el-table-column label="Owner" prop="content_owner" sortable="custom" width="120"></el-table-column>
          <el-table-column label="Uploaded By" prop="users.first_name" @click="handleSort('user.first_name')" sortable width="120" >
            <template slot-scope="props">
              <el-tooltip :content="props.row.user ? `${props.row.user.first_name} ${props.row.user.surname}` : 'Unknown'"
                          placement="top"> <span class="pointer">{{ uploadedBy(props.row.user) }}</span> </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column v-if="shouldShowColumn('generated')" label="Generated" width="100%" props="generated">
            <template slot-scope="props">
              <el-tag v-if="props.row.files_generated" type="success">
                Yes
              </el-tag>
              <el-tag v-else type="danger">
                No
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column v-if="shouldShowColumn('published')" label="Published" width="100%" props="published">
            <template slot-scope="props">
              <el-tag v-if="props.row.user_publish === 1" type="success">
                Yes
              </el-tag>
              <el-tag v-else type="danger">
                No
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column  v-if="shouldShowColumn('timing_period')" label="Timing period" width="140%" props="timing_period">
            <template slot-scope="props">
              <span v-if="props.row.timing_start">
                {{ props.row.timing_start | day_month }} -
                {{ props.row.timing_end | date }}
              </span>
              <span v-else>Timing not set</span>
            </template>
          </el-table-column>
          <el-table-column label="Analysis ">
            <template slot-scope="props">
              <el-tag v-if="!props.row.analysis" type="warning">None</el-tag>
              <el-tag v-else-if="props.row.analysis === 'InProgress'" type="info">
                <i class="fa fa-spinner fa-spin"></i> Analyzing
              </el-tag>
              <el-tag v-else-if="props.row.analysis === 'Finished'" type="success">
                {{ props.row.analysis }}
              </el-tag>
              <el-tag v-else-if="props.row.analysis === 'Failed'" type="error">
                {{ props.row.analysis }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Actions" align="right" width="320">
            <template slot-scope="props">
              <el-tooltip v-if="+props.row.user_publish !== 2" content="Status" placement="top">
                <el-popover placement="left" trigger="click" width="300">
                  <el-button slot="reference" class="mr10"
                             circle size="small" icon="el-icon-check"></el-button>
                  <div class="video-status">
                    <p class="m0">Edit status for track <b>{{ props.row.title }}</b></p>
                    <el-radio-group class="mt10" v-model="props.row.approved" size="small"
                                    @change="changeTrackStatus($event, props.row)">
                      <el-radio-button :label="1">Approve{{ props.row.approved === 1 ? 'd' : ''}}</el-radio-button>
                      <el-radio-button :label="2">Reject{{ props.row.approved === 2 ? 'ed' : ''}}</el-radio-button>
                    </el-radio-group>

                    <el-radio-group class="mt10" v-model="props.row.delivered" size="small"
                                    @change="changeDeliveredStatus($event, props.row)">
                      <el-radio-button :label="true">Delivered</el-radio-button>
                      <el-radio-button :label="false">Not Delivered</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-popover>
              </el-tooltip>
              <el-tooltip content="Allow" placement="top" v-if="hasCopyrightError(props.row.errors)">
                <el-button type="info" circle size="small" icon="el-icon-star-off" @click="allow(props.row.id)">
                </el-button>
              </el-tooltip>
              <el-tooltip
                content="Generate files"
                placement="top"
                v-if="!props.row.files_generated"
              >
                <el-button
                  type="primary"
                  circle
                  size="small"
                  icon="el-icon-refresh"
                  @click="generate(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="Publish"
                placement="top"
                v-if="props.row.user_publish !== 1"
              >
                <el-button
                  type="success"
                  circle
                  size="small"
                  icon="el-icon-top"
                  @click="publish(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="Edit" placement="top" v-if="props.row.user_publish !== 1">
                <el-button
                  type="warning"
                  circle
                  size="small"
                  icon="el-icon-edit"
                  @click="openEdit(props.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                content="Delete"
                placement="top"
                v-if="props.row.user_publish !== 1"
              >
                <el-button
                  type="danger"
                  circle
                  size="small"
                  icon="el-icon-close"
                  @click="deleteT(props.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip v-if="!props.row.analysis" content="Analyze" placement="top">
                <el-button type="info" circle size="small" icon="el-icon-video-play" @click="analyzeTrack(props.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="width: 700px; margin: auto"
            background @size-change="sizeChange" @current-change="currentChange"
                       :current-page="data.current_page" :page-sizes="[10, 25, 50]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="data.total"
        ></el-pagination>
<!--        </div>-->
        </div>
      </el-card>
    </el-col>
    <CountryModal />
    <DialogACRMetadata />
  </el-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import DialogTrack from './DialogTrack'
import DialogACRMetadata from "@/modules/admin/track-import/components/DialogACRMetadata.vue"
import CountryModal from "./CountryModal.vue";
import Waveform from './Waveform.vue'
import axios from '@/plugins/axios'

export default {
  data() {
    return {
      trackForDownload: [],
      showWaveform: null,
      trackStatus: {
        '0': 'All', '1': 'Promotion', '2': 'Submitted', '3': 'Pending', '4': 'Delivered'
      },
      selectedTracks: [],
      sortColumn: 'created_at',
      sortOrder: 'desc',
      selectAll: false,
    }
  },
  components: {
    DialogTrack, CountryModal, Waveform, DialogACRMetadata
  },

  computed: {
    ...mapState('trackImport', ['loading', 'data','pricing', 'download_track', 'currentPage', 'pageSize', 'status'])
  },

  watch: {
    '$store.state.trackImport.selectAllTracks'(newVal) {
      if (this.selectAll) {
        this.selectedTracks = [...newVal];
      }
    }
  },
  methods: {
    ...mapActions('trackImport', [
      'read',
      'generate',
      'userPublish',
      'deleteTrack',
      'setApproveStatus',
      'setDeliveredStatus',
      'downloadTrack',
      'bulkAnalyzeTrack',
      'analyzeTrack',
      'ddex_dialog',
      'allow',
      'batchAction',
      'importSelectAllIds',
    ]),
    ...mapMutations('newReleasesArtists', ['setOrdering']),
    ...mapMutations('trackImport', [
      'setTrack',
      'setDialogTrack',
      'setDialogUpload',
      'setUploadImage',
      'setGenres',
      'setMoods',
      'setRestrictions',
      'setSocials',
      'setPricing',
      'setDownloadTrack',
      'setCountryModal',
      'setDialogDDEX',
      'setAcrCloudDataDialog',
      'setPageSize',
      'setCurrentPage',
      'setStatus',
      'setSortColumn',
      'setSortOrder',
    ]),

    handleSort({ prop, order }) {
      if (!prop || !order) {
            this.sortColumn = 'created_at';
            this.sortOrder = 'desc';
        } else {
            this.sortColumn = prop;
            this.sortOrder = order === 'ascending' ? 'asc' : 'desc';
      }
    
      this.setSortColumn(this.sortColumn);
      this.setSortOrder(this.sortOrder);
      this.read();
    },

    sizeChange(page) {
      this.setPageSize(page)
      this.read()
    },

    currentChange(page) {
      this.setCurrentPage(page)
      this.read()
    },

    setTrackStatus(status) {
      this.setStatus(status)
      this.setCurrentPage(1)
      this.read()
      this.selectedTracks = [];
      this.selectAll = false;
    },
    
    shouldShowColumn(column) {
      // '0': 'All', '1': 'Promotion', '2': 'Submitted', '3': 'Pending', '4': 'Delivered'
      const columnVisibility = {
        submitted_at: [0, 1, 2, 3, 4],
        approved_at: [0, 1, 2, 4],
        ingested_at: [0, 1, 4],
        generated: [0, 1],
        published: [0, 1],
        timing_period: [0, 1], 
      };

      if (columnVisibility[column]) {
        return columnVisibility[column].includes(Number(this.status));
      }
  
      return false;
    },

    tableRowClassName({ row }) {
      if (+row.user_publish === 2) return 'pending-row'
      if (+row.approved === 1 && row.delivered == false) return 'approved-row'
      if (+row.approved === 1 && row.delivered === true) return 'delivered-row'
      else if (+row.approved === 2) return 'rejected-row'
      return ''
    },

    uploadedBy(user) {
      if (user) {
        let obj = { sysadmin: 'Admin', label_admin: 'Label', artist_admin: 'Artist' }
        return obj[user.user_level] || 'Unknown'
      }
      return 'Unknown'
    },

    publish(id) {
      this.$confirm('You will publish this track. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.userPublish(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
    },

    openModal(track) {
      this.setCountryModal(true)
      this.setTrack(track)
    },

    generateAll() {
      if (this.selectedTracks.length === 0) {
        this.$message({
          type: 'warning',
          message: 'Please select tracks that have not been generated.',
        });
        return;
      }

      // Filter only tracks that have NOT been generated
      const tracksToGenerate = this.selectedTracks.filter(trackId => {
        const track = this.data.data.find(t => t.id === trackId);
        return track && !track.files_generated;
      });

      if (tracksToGenerate.length === 0) {
        this.$message({
          type: 'info',
          message: 'Selected track(s) is/are already generated.',
        });
        return;
      }

      // Build confirmation message
      let confirmMessage = '';
      if (tracksToGenerate.length < this.selectedTracks.length) {
        confirmMessage += `<small>Some selected tracks are already generated and will be ignored.</small><br>`;
      }
      confirmMessage += `You will generate files for ${tracksToGenerate.length} selected track(s). Continue?`;


      this.$confirm(confirmMessage, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        dangerouslyUseHTMLString: true,
        type: 'warning',
      })
          .then(() => {
            this.generate(tracksToGenerate); // Pass only ungenerated tracks
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Generate cancelled',
            });
          });
    },

    changeTrackStatus(value, track) {
      track.approved = value
      this.setApproveStatus(track)
    },

    changeDeliveredStatus(value, track) {
      console.log(value)
      track.delivered = value
      this.setDeliveredStatus(track)
    },

    publishAll() {
      if (this.selectedTracks.length > 0) {
      this.$confirm('You will publish tracks. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.userPublish(this.selectedTracks)
          this.selectedTracks = [];
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Publish cancelled'
          })
        })
      } else {
        this.$message({
          type: 'warning',
          message: 'Please select tracks to publish.',
        });
      }
    },

    hasCopyrightError(errors) {
      let _has = false
      errors.forEach(error => {
        if (error.toLowerCase().includes('copyright')) _has = true
      })
      return _has
    },

    deleteT(id) {
      this.$confirm(
        'You will permanently delete this track. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.deleteTrack(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },

    handleDownloadTracks() {
      if (this.selectedTracks.length > 0) {
        this.downloadTrack(this.selectedTracks);
        this.selectedTracks = [];
      } else {
        this.$message({
          type: 'warning',
          message: 'Please select tracks to download.',
        });
      }
    },

    handleAnalyzeTracks() {
      if (this.selectedTracks.length > 0) {
        this.bulkAnalyzeTrack(this.selectedTracks);
        this.selectedTracks = [];
      } else {
        this.$message({
          type: 'warning',
          message: 'Please select tracks for analyse.',
        });
      }
    },

    showCheckboxes() {
      this.setDownloadTrack(!this.download_track)
    },

    // handleSort({ prop, order }) {
    // if (order) {
    //   this.data.data.sort((a, b) => {
    //     const aValue = a[prop];
    //     const bValue = b[prop];
        
    //     if (aValue === bValue) return 0;
    //     if (order === 'ascending') {
    //       return aValue > bValue ? 1 : -1;
    //     } else {
    //       return aValue < bValue ? 1 : -1;
    //     }
    //   });
    // } else {
    //   // If no sorting order, reload the default dataset (from API or initial state)
    //   this.read();
    // }
    // },

    openEdit(track) {
      if (track.short_challenge.budget > 0) track.short_challenge.budget = track.short_challenge.budget / 10;
      if (track.short_challenge.guaranteed_payment > 0) track.short_challenge.guaranteed_payment = track.short_challenge.guaranteed_payment / 10;
      if (track.short_challenge.bonus_payment > 0) track.short_challenge.bonus_payment = track.short_challenge.bonus_payment / 10;

      if (track.tiktok_challenge.budget > 0) track.tiktok_challenge.budget = track.tiktok_challenge.budget / 10;
      if (track.tiktok_challenge.guaranteed_payment > 0) track.tiktok_challenge.guaranteed_payment = track.tiktok_challenge.guaranteed_payment / 10;
      if (track.tiktok_challenge.bonus_payment > 0) track.tiktok_challenge.bonus_payment = track.tiktok_challenge.bonus_payment / 10;

      if (track.instagram_challenge.budget > 0) track.instagram_challenge.budget = track.instagram_challenge.budget / 10;
      if (track.instagram_challenge.guaranteed_payment > 0) track.instagram_challenge.guaranteed_payment = track.instagram_challenge.guaranteed_payment / 10;
      if (track.instagram_challenge.bonus_payment > 0) track.instagram_challenge.bonus_payment = track.instagram_challenge.bonus_payment / 10;
      this.setDialogTrack(true)
      this.setTrack(JSON.parse(JSON.stringify(track)))
      this.setUploadImage(track.image_url)
      track.tiktok_pricing =  this.pricing.map(obj1 => {
        const obj2 = track.tiktok_challenge ? track.tiktok_challenge.pricing.find(obj2 => obj2.pricing_id === obj1.id) :{};
        return {
          id: obj1.id,
          threshold: obj1.threshold,
          payment: obj2 ? obj2.payment : null
        }
      });
      track.instagram_pricing =  this.pricing.map(obj1 => {
        const obj2 = track.instagram_challenge ? track.instagram_challenge.pricing.find(obj2 => obj2.pricing_id === obj1.id) :{};
        return {
          id: obj1.id,
          threshold: obj1.threshold,
          payment: obj2 ? obj2.payment : null
        }
      });
      track.short_pricing =  this.pricing.map(obj1 => {
        const obj2 = track.short_challenge ? track.short_challenge.pricing.find(obj2 => obj2.pricing_id === obj1.id): {};
        return {
          id: obj1.id,
          threshold: obj1.threshold,
          payment: obj2 ? obj2.payment : null
        }
      });
    },

    openMetadata(track) {
      this.setAcrCloudDataDialog(true)
      this.setTrack(track)
    },

    async performBatchAction({ status }) {
      if (this.selectedTracks.length > 0) {
        await this.batchAction({
          status,
          tracks: this.selectedTracks
        });
        this.selectedTracks = [];
        this.selectAll = false;
      } else {
        if(status === 'ingest') {
          status = 'deliver'
        }
        this.$message({
          type: 'warning',
          message: `Please select tracks to ${status}.`,
        });
      }
    },

    async toggleSelectAll() {
      if (this.selectAll) {
        await this.importSelectAllIds(); // Trigger the action to fetch all track IDs
      } else {
        this.selectedTracks = []; // Clear selection if selectAll is unchecked
      }
    },
  },

  async created() {
    this.read()
    this.setOrdering({column: 'artist.name', type:'asc'})

    let genres = await axios.api.get('/genres')
    if (genres.data.success) this.setGenres(genres.data.genres)

    let moods = await axios.api.get('/moods')
    if (moods.data.success) this.setMoods(moods.data.moods)

    let restrictions = await axios.api.get('/restrictions')
    if (restrictions.data.success) this.setRestrictions(restrictions.data.restrictions)

    let { data } = await axios.api.get('/socials')
    if (data) this.setSocials(data)

    let pricing = await axios.api.get('/challenge/pricing')
    if (pricing.data.success) {
      pricing.data.pricing.forEach(obj => {
        obj.payment = null; //added payment field for dialog form
      });
      this.setPricing(
        pricing.data.pricing
      )
    }
  },

  mounted() {
    window.Echo.private('track.processed').listen('.track.processed', e => {
      if (!e.trackId && e.serviceError) {
        this.$message({ type: 'error', message: e.serviceError })
        return
      }
      let searchCyaniteTrack = this.data.find(
        track => +track.cyaniteId === +e.trackId
      )
      if (searchCyaniteTrack) {
        searchCyaniteTrack.analysis = e.status

        if (e.status === 'Finished') this.read()
      }
    })
  }
}
</script>

<style lang="scss">
.import-user .item {
  margin-top: 1rem;
  cursor: pointer;
}

.import-user .checkbox-track span {
  width: 20px;
  height: 20px;
  border-color: #e55279;
}

.el-table .approved-row {
  background: rgba(1,131,249,.3);
}

.el-table .rejected-row {
  background: rgba(208,110,110,.3);
}

.el-table .pending-row {
  background: rgba(230,162,60,.3);
}

.el-table .delivered-row {
  background: rgba(125, 206, 175, .3);
}

.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: rgba(136, 132, 132, 0.7);
}

.checkbox-track .el-checkbox__label {
  display: none;
}

.btn-approve {
  background: rgba(1,131,249, 1);
  border-color: rgba(1,131,249, 1);
}
.btn-reject {
  background: rgba(208,110,110,1);
  border-color: rgba(208,110,110,1);;
}
.btn-ingest {
  background: rgba(125, 206, 175, 1);
  border-color: rgba(125, 206, 175, 1);
}
.el-checkbox__inner::after {
  height: 10px;
  left: 7px;
}
.import-table-wrap {
  //overflow-x: scroll;
  max-width: 100%;
  & > div {
    width: 2200px;
  }
}
.import-table-wrap .checkbox-track {
  display: flex;
}

</style>
